// assets
import PaletteIcon from '@mui/icons-material/Palette';
import WbShadeIcon from '@mui/icons-material/WbShade';
import FlagIcon from '@mui/icons-material/Flag';

// constant
const icons = {
  PaletteIcon,
  WbShadeIcon,
  FlagIcon
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
  id: 'utilities',
  title: 'Utilities',
  type: 'group',
  children: [
    {
      id: 'util-shadow',
      title: 'Shadow',
      type: 'item',
      url: '/utils',
      icon: icons.WbShadeIcon,
      breadcrumbs: false
    },
    {
      id: 'icons',
      title: 'AABB',
      type: 'collapse',
      icon: icons.FlagIcon,
      children: [
        {
          id: 'AA',
          title: 'A',
          type: 'item',
          url: '/aa',
          breadcrumbs: false
        },
        {
          id: 'BB',
          title: 'B',
          type: 'item',
          url: '/bb',
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default utilities;
